import { render, staticRenderFns } from "./CustomersMainComponent.vue?vue&type=template&id=4ea1d008&scoped=true&"
import script from "./CustomersMainComponent.vue?vue&type=script&lang=js&"
export * from "./CustomersMainComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea1d008",
  null
  
)

export default component.exports